import { UploadFile, UploadFileLike } from 'types/components';
import { UploadedFile } from 'types/models';

const isUploadFileLike = (value: unknown): value is UploadFileLike => Boolean(
  value
  && typeof value === 'object'
  && 'uid' in value
  && 'name' in value,
);

const isUploadFile = (value: unknown): value is UploadFile => Boolean(
  isUploadFileLike(value) && value.originFileObj instanceof File,
);

const mapUploadedFileToUploadFile = (file: UploadedFile): UploadFileLike => ({
  uid: file.type,
  name: file.name,
});

const downloadFile = (object: Blob, name: string) => {
  const url = window.URL.createObjectURL(object);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', name);

  document.body.appendChild(link);

  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

const openFile = (object: Blob) => {
  const url = window.URL.createObjectURL(object);

  window.open(url);

  window.URL.revokeObjectURL(url);
};

const file = {
  isUploadFileLike,
  isUploadFile,
  mapUploadedFileToUploadFile,
  downloadFile,
  openFile,
};

export default file;
